var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.values),function(item){return _c('div',{key:item.label},[_c('asc-descriptions-item',{attrs:{"label":item.label,"value":item.value}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }